module.exports = __webpack_public_path__ + "media/images/icon_baseinfo_calendar-0269c10fc5bd007c4c977d8cedd83b4e.png";